import apiClient from './apiClient';
import { User } from '../types/user';
import { AxiosResponse } from 'axios'; // Importiamo il tipo di risposta di Axios

// --- Interfacce per i dati JSON nelle risposte ---
interface LoginResponse {
  access_token: string;
  refresh_token: string;
  user: User;
}
interface TwoFactorResponse {
  message: string;
  two_fa_token: string;
}
interface QrCodeResponse {
    qr_code_image: string;
}
interface MessageResponse {
  message: string;
}


// --- Servizio di Autenticazione (Completo) ---
export const authService = {
  /**
   * Esegue il primo step del login.
   * Restituisce l'intera risposta HTTP (dati + status code).
   */
  login: (email: string, password: string): Promise<AxiosResponse<LoginResponse | TwoFactorResponse>> => {
    return apiClient.post('/api/auth/login', { email, password });
  },

  /**
   * Esegue il secondo step del login (verifica 2FA).
   */
  verify2FA: async (two_fa_token: string, totp_code: string): Promise<LoginResponse> => {
    const response = await apiClient.post<LoginResponse>(
      '/api/auth/verify-2fa',
      { totp_code },
      { headers: { Authorization: `Bearer ${two_fa_token}` } }
    );
    if (response.data.access_token) {
      localStorage.setItem('access_token', response.data.access_token);
      localStorage.setItem('refresh_token', response.data.refresh_token);
    }
    return response.data;
  },

  /**
   * Esegue il logout.
   */
  logout: (): void => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    sessionStorage.removeItem('2fa_token');
  },

  /**
   * Recupera i dati dell'utente loggato.
   */
  getCurrentUser: (): Promise<User> => {
    return apiClient.get('/api/auth/me').then(res => res.data);
  },

  /**
   * Genera il QR code per la configurazione 2FA.
   */
  generate2FA: (): Promise<QrCodeResponse> => {
    return apiClient.post('/api/2fa/generate').then(res => res.data);
  },

  /**
   * Abilita la 2FA dopo la verifica.
   */
  enable2FA: (totp_code: string): Promise<MessageResponse> => {
    return apiClient.post('/api/2fa/verify-and-enable', { totp_code }).then(res => res.data);
  },

  /**
   * Inizia il processo di recupero password.
   */
  forgotPassword: (email: string): Promise<MessageResponse> => {
    return apiClient.post('/api/auth/forgot-password', { email }).then(res => res.data);
  },

  /**
   * Finalizza il recupero password.
   */
  resetPassword: (token: string, password: string): Promise<MessageResponse> => {
    return apiClient.post(`/api/auth/reset-password/${token}`, { password }).then(res => res.data);
  },
};
